module.exports = __webpack_public_path__ + "img/liangbin.d79f181b.jpg";